module.exports = __webpack_public_path__ + "img/home_zone_vs_type1.adc22510.png";